import React from 'react';

interface Props {
  title: string;
  children: React.ReactNode;
  'data-testid'?: string;
}

/** One way to get a file, headed so side-by-side options read as alternatives. */
export function ImportOption({ title, children, ...rest }: Props) {
  return (
    <section className="space-y-2" data-testid={rest['data-testid']}>
      <h3 className="px-1 text-xl font-bold tracking-tight text-gray-900 dark:text-white">
        {title}
      </h3>
      {children}
    </section>
  );
}
